// Maintenance route — site-wide kill switch while a new engine is built.
//
// **How to take the site live again**: revert the PR that introduced this
// route + the App.tsx change that renders it (search the repo for
// "claude/maintenance-mode" in git log). The Chart + Landing + NotFound
// routes are untouched in source; flipping App.tsx back to the prior
// Routes block restores the full site.
//
// Worker (`server.kiwicharts.com`) is intentionally NOT touched — only the
// browser frontend is gated. The Worker API stays alive so the rebuild
// can use the existing trade-tape + bar-cache infrastructure.

export function Maintenance() {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#0d0d12",
                color: "#e8e8ee",
                fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, " +
                    "Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
                padding: "2rem",
                textAlign: "center",
                lineHeight: 1.5,
            }}
        >
            <div style={{ fontSize: "3rem", marginBottom: "1.5rem" }}>
                KiwiCharts
            </div>
            <div style={{ fontSize: "1.2rem", color: "#a0a0aa", maxWidth: "32rem" }}>
                We're rebuilding the engine. The site is offline while we work.
            </div>
            <div
                style={{
                    fontSize: "0.95rem",
                    color: "#6a6a78",
                    marginTop: "1.5rem",
                    maxWidth: "32rem",
                }}
            >
                Check back soon.
            </div>
        </div>
    );
}
